<script setup lang="ts">
import ProfilePicture from './ProfilePicture.vue';
import {
  useEmployeeWithTimesheetsStore,
  ShiftStatus,
} from '@/stores/employeesWithTimesheets/employeesWithTimesheets';
import type { Employee } from '@/lib/request/types/employee';

const props = defineProps<{
  employee: Employee;
  photo: string;
  displayName: string;
  shiftLabel?: string;
  comingUpLabel?: string;
}>();

const emit = defineEmits(['select']);

function getStatusClass() {
  const employeeWithTimesheets = useEmployeeWithTimesheetsStore();
  const statusValue = employeeWithTimesheets.getStatusValueForEmployee(
    props.employee?.Id
  );

  switch (statusValue) {
    case ShiftStatus.Late:
      return '__status--late';
    case ShiftStatus.OnShift:
      return '__status--on-shift';
    case ShiftStatus.OnBreak:
      return '__status--on-break';
    case ShiftStatus.Scheduled:
      return '__status--scheduled';
    default:
      return '';
  }
}
</script>

<template>
  <div class="__employee-row" @click="emit('select')">
    <ProfilePicture
      :src="props.photo"
      size="small"
      :status="getStatusClass()"
    />
    <div class="__left-info">
      <p class="__display-name">
        {{ props.displayName }}
      </p>
      <p class="__scheduled-time">{{ props.shiftLabel }}</p>
    </div>
    <div class="__coming-up">
      <p class="__coming-up__label">{{ props.comingUpLabel }}</p>
    </div>
  </div>
</template>

<style scoped>
.__employee-row {
  cursor: pointer;
  padding: 20px 15px;
  border: 1px solid var(--co-lines-border-solid);
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
}

.__employee-row:hover {
  background: #f9f9fb;
}

.__display-name {
  text-transform: capitalize;
  font-size: 17px;
  color: var(--co-text-primary);
  width: 100%;
}

.__scheduled-time {
  margin-top: 4px;
  font-size: 13px;
  color: var(--co-text-secondary);
}

.__coming-up {
  margin-left: auto;
}

.__coming-up__label {
  font-size: 15px;
  color: var(--co-text-secondary);
}
</style>
